import axios from 'axios';
import Qs from 'qs';

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
	(config) => {
		let usersInfo = localStorage.getItem('usersInfo')
			? JSON.parse(localStorage.getItem('usersInfo'))
			: '';
		if (usersInfo && usersInfo.token) {
			config.headers.token = usersInfo.token;
		} else {
			config.headers.token = '';
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// http response 拦截器
axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response) {
			if (
				error.response.status === 500 &&
				error.response.data.message === '用户未登录'
			) {
				localStorage.removeItem('usersInfo');
				sessionStorage.removeItem('Authorization');
				window.location.href =
					'http://' + window.location.host + '/index.html#/Index';
			}
			if (
				error.response.status === 500 &&
				error.response.data.message === '未订购该产品'
			) {
				window.location.href =
					'http://' + window.location.host + '/index.html#/Index';
			}
		}
		return Promise.reject(error.response.data);
	}
);

// 设置全局axios默认值
axios.defaults.timeout = 2000000; // 20000的超时验证
axios.defaults.withCredentials = true; // 跨域带cookie

async function http(type, url, contentType, params) {
	let contentTypeUse =
		contentType === 'json'
			? 'application/json'
			: 'application/x-www-form-urlencoded';
	let paramsUse = contentType === 'json' ? params : Qs.stringify(params);

	try {
		let response;
		if (type === 'get') {
			response = await axios({
				withCredentials: true,
				method: 'get',
				url: url,
			});
		} else if (type === 'get2') {
			response = await axios({
				withCredentials: true,
				method: 'get',
				url: url,
				params: params,
				headers: { 'Content-Type': contentTypeUse },
			});
		} else if (type === 'put') {
			response = await axios({
				method: 'put',
				url: url,
				params: params,
			});
		} else if (type === 'delete') {
			response = await axios({
				method: 'delete',
				url: url,
				params: params,
			});
		} else if (type === 'post2') {
			response = await axios({
				method: 'post',
				url: url,
				headers: { 'Content-Type': contentTypeUse },
				params: params,
			});
		} else {
			response = await axios({
				method: 'post',
				url: url,
				headers: { 'Content-Type': contentTypeUse },
				data: paramsUse,
			});
		}
		return response.data;
	} catch (error) {
		throw error;
	}
}

export default http;



// WEBPACK FOOTER //
// ./static/common/api/axiosTwo.js